import {
  STATUS_COMPLETED,
  STATUS_IN_PROGRESS,
  STATUS_NOT_STARTED,
} from 'helpers/jobs'

export const formatUnitsData = (units, unitList, savedUnitIds) => {
  const newData = []
  let selectedUnitIds = savedUnitIds && savedUnitIds.length ? savedUnitIds : []

  if (units && units.length) {
    selectedUnitIds = units.map(unit =>
      Object.keys(unit).length > 1
        ? unit.locus
        : unit.locus_group || unit.locus,
    )
  }

  if (Object.keys(unitList).length) {
    ;[...unitList.groups, ...unitList.no_groups].forEach(
      ({ id, name, containerName, locuses }, idx) => {
        const hasGroup = unitList.groups.some(group => group.name === name)
        const checkParentStatus = () => {
          if (selectedUnitIds.length) {
            if (selectedUnitIds.indexOf(id) !== -1) {
              return STATUS_COMPLETED
            }

            if (
              locuses &&
              selectedUnitIds.some(item =>
                locuses.find(locus => locus.id === item),
              )
            ) {
              return STATUS_IN_PROGRESS
            }
          }

          return STATUS_NOT_STARTED
        }
        const childData = []

        if (locuses) {
          locuses.forEach((childItem, childIdx) => {
            const checkChildStatus = () => {
              if (selectedUnitIds.length) {
                if (
                  selectedUnitIds.indexOf(id) !== -1 ||
                  selectedUnitIds.indexOf(childItem.id) !== -1
                ) {
                  return STATUS_COMPLETED
                }
              }

              return STATUS_NOT_STARTED
            }

            childData.push({
              id: childItem.id,
              key: `${id}_${childItem.id}`,
              name: childItem.name || childItem.containerName,
              type: 'locus',
              level: 'second',
              index: childIdx,
              selected: checkChildStatus(),
              parentId: id,
            })
          })
        }

        newData.push({
          id,
          key: `${name || containerName}_${id}`,
          name: name || containerName,
          type: hasGroup ? 'locus_group' : 'locus',
          level: 'first',
          index: idx,
          selected: checkParentStatus(),
          childData,
        })
      },
    )
  }

  return newData
}

export const formatExportUnitsData = data =>
  data.reduce((total, { id, type, selected, childData }) => {
    if (childData && childData.length) {
      if (selected === STATUS_COMPLETED) {
        total.push({ locus_group: id })
      }

      if (selected === STATUS_IN_PROGRESS) {
        const children = childData.reduce((result, childItem) => {
          if (childItem.selected === STATUS_COMPLETED) {
            result.push({
              locus_group: childItem.parentId,
              locus: childItem.id,
            })
          }

          return result
        }, [])

        total.push(...children)
      }
    } else if (selected === STATUS_COMPLETED) {
      total.push({ [type]: id })
    }

    return total
  }, [])
